import { useMemo } from "react";
import { isNil } from "lodash";
import get from "lodash/get";
import { useTranslation } from "react-i18next";
import { invariant } from "@searchui-searchforms/shared/utils";
import { DATE_EXACTNESS_OPTIONS } from "@/shared/constants/date-exactness";
import { useFormAPI, useFormStore } from "@/shared/forms";
import { useFieldContext } from "../FieldContext";
import { ExactnessSingleSelect } from "./ExactnessSingleSelect";

export function YearExactness() {
    const { t } = useTranslation();
    const { fieldPath, exactnessFieldPath } = useFieldContext();

    invariant(exactnessFieldPath, "exactnessFieldPath is required");

    const yearExactnessOptions = useMemo(
        () =>
            DATE_EXACTNESS_OPTIONS.map((option) => ({
                fullLabel: t(option.fullLabel),
                label: t(option.label),
                id: option.id,
                value: option.id,
            })),
        [t],
    );

    const { setFieldValue } = useFormAPI();
    const year = useFormStore(({ values }) => get(values, fieldPath)) as number;
    const exactness = useFormStore(({ values }) => get(values, exactnessFieldPath)) as number | null;

    const value = isNil(exactness) ? null : String(exactness);
    const selectedOption = yearExactnessOptions.find((option) => option.value === value);

    const isExact = !isNil(value);
    const baseLabel = selectedOption ? selectedOption.fullLabel : t("year.exactness.exact");
    const label = isExact ? baseLabel : `${baseLabel} +/-...`;

    if (!year) return null;

    return (
        <ExactnessSingleSelect
            value={value}
            options={yearExactnessOptions}
            onChange={(nextValue) => {
                setFieldValue(exactnessFieldPath, isNil(nextValue) ? null : Number(nextValue));
            }}
            label={label}
            testId={exactnessFieldPath}
        />
    );
}
